import { HelpCircleIcon } from '@approvalmax/ui';
import {
    Flex,
    Form,
    PasswordField,
    PasswordValidation,
    PhoneField,
    TextField,
    Tooltip,
} from '@approvalmax/ui/src/components';
import React, { memo } from 'react';

import { fields } from '../../constants';
import { useProfileSetupFormContext } from '../ProfileSetupForm/ProfileSetupForm.hooks';
import { messages } from '../ProfileSetupForm/ProfileSetupForm.messages';
import { FormSectionAccountInfoProps } from './FormSectionAccountInfo.types';

export const FormSectionAccountInfo = memo<FormSectionAccountInfoProps>((props) => {
    const { showPhoneField, showPasswordField } = props;

    const { watch } = useProfileSetupFormContext();

    const password = watch(fields.fieldNamePassword);

    return (
        <Form.Part>
            <Flex container wrap={true} spacing='16'>
                <Flex size={12}>
                    <TextField
                        name={fields.fieldNameFirstName}
                        placeholder={messages.fieldFirstNamePlaceholder}
                        initFocus
                        clearable={false}
                    />
                </Flex>

                <Flex size={12}>
                    <TextField
                        name={fields.fieldNameLastName}
                        placeholder={messages.fieldLastNamePlaceholder}
                        clearable={false}
                    />
                </Flex>

                {showPhoneField && (
                    <Flex size={24}>
                        <PhoneField
                            name={fields.fieldNamePhone}
                            placeholder={messages.fieldPhonePlaceholder}
                            endIcon={
                                <Tooltip isHovering activator={<HelpCircleIcon size={16} />}>
                                    {messages.fieldPhoneTooltip}
                                </Tooltip>
                            }
                        />
                    </Flex>
                )}

                {showPasswordField && (
                    <Flex size={24}>
                        <PasswordField
                            name={fields.fieldNamePassword}
                            placeholder={messages.fieldPasswordPlaceholder}
                            maxLength={180}
                        />
                    </Flex>
                )}

                {showPasswordField && password && (
                    <Flex size={24}>
                        <PasswordValidation value={password} invalid={false} />
                    </Flex>
                )}
            </Flex>
        </Form.Part>
    );
});

FormSectionAccountInfo.displayName = 'FormSectionAccountInfo';
